<template>
	<div class="color-box" :class="visible ? 'visible-transition scale transition-delay-'+delay+' '+cssClass+'' : 'invisible-transition scale '+cssClass+''">
		<h3 class="color-box-headline">{{ text }}</h3>
	</div>
</template>

<script>
	export default {
		props: {
	    visible: {
        default: () => false
	    },
	    delay: {
        default: () => 0
	    },
	    text: {
        default: () => ''
	    },
	    cssClass: {
        default: () => ''
	    }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/ColorBox.vue